module.exports = __webpack_public_path__ + "img/space-station-moon-construction.c152b1fd.svg";